const _excluded = ["checked", "partiallyChecked", "disabled", "id", "className", "onChange", "children", "error", "name", "value", "inline", "tooltip", "label", "labelInfo", "data-testid", "testid"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useMemo, useState } from 'react';
import cn from 'classnames';
import { getTestIds } from "../../utils/TestIds";
import { Tooltip } from "../Tooltip";
import { Typography } from "../Typography";
import { WithInfoIcon } from "../WithInfoIcon/WithInfoIcon";
import styles from "./Checkbox.module.scss";
import { CheckedIcon } from "./CheckedIcon";
import { PartiallyCheckedIcon } from "./PartiallyCheckedIcon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetCheckboxLabelTID = parentTestId => getTestIds({
  parentTestId,
  deprecatedTestIds: {
    CheckboxLabelTID: {
      Input: parentTestId ? "".concat(parentTestId, "-input") : undefined,
      Icon: parentTestId ? "".concat(parentTestId, "-icon") : undefined
    }
  }
});
export const Checkbox = /*#__PURE__*/React.forwardRef(function Checkbox(props, ref) {
  const {
      checked,
      partiallyChecked,
      disabled,
      id,
      className,
      onChange: _onChange,
      children,
      error,
      name,
      value,
      inline,
      tooltip,
      label,
      labelInfo,
      'data-testid': testidOld,
      testid = testidOld
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    CheckboxLabelTID
  } = useMemo(() => GetCheckboxLabelTID(testid), [testid]);
  const [isChecked, setIsChecked] = useState(checked || false);
  const isControlled = typeof checked !== 'undefined';

  // Makes sure the internal state reflects the provided checked prop.
  useEffect(() => {
    if (typeof checked !== 'undefined') {
      setIsChecked(checked);
    }
  }, [checked]);
  const LabelWithInfoIcon = () => /*#__PURE__*/_jsx(WithInfoIcon, {
    info: labelInfo || '',
    showInfo: !!labelInfo,
    infoTestId: CheckboxLabelTID.LabelInfo(),
    children: /*#__PURE__*/_jsx(Typography, {
      skin: disabled ? 'disabled' : 'standard',
      "data-testid": CheckboxLabelTID.Label(),
      children: label
    })
  });
  const checkbox = /*#__PURE__*/_jsxs("label", _objectSpread(_objectSpread({}, rest), {}, {
    "data-testid": testid,
    className: cn(styles.root, {
      [styles.disabled]: disabled,
      [styles.inline]: inline
    }, className),
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.checkbox,
      children: [/*#__PURE__*/_jsx("input", {
        id: id,
        className: styles.input,
        ref: ref,
        type: "checkbox",
        disabled: disabled,
        checked: isChecked,
        "data-testid": CheckboxLabelTID.Input(),
        onChange: e => {
          if (!isControlled) {
            setIsChecked(e.currentTarget.checked);
          }
          _onChange && _onChange(e);
        },
        "aria-invalid": error,
        name: name,
        value: value,
        "data-state": partiallyChecked ? 'partially-checked' : isChecked ? 'checked' : 'unchecked'
      }), /*#__PURE__*/_jsxs("div", {
        "data-testid": CheckboxLabelTID.Icon(),
        className: cn(styles.checkboxIndicator, {
          [styles.checked]: isChecked && !partiallyChecked,
          [styles.unchecked]: !isChecked && !partiallyChecked,
          [styles.partiallyChecked]: partiallyChecked,
          [styles.error]: error
        }),
        children: [isChecked && !partiallyChecked && /*#__PURE__*/_jsx(CheckedIcon, {}), partiallyChecked && /*#__PURE__*/_jsx(PartiallyCheckedIcon, {})]
      })]
    }), children ? children : /*#__PURE__*/_jsx(LabelWithInfoIcon, {})]
  }));
  return tooltip ? /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({}, tooltip), {}, {
    children: /*#__PURE__*/_jsx("div", {
      children: checkbox
    })
  })) : checkbox;
});